module.exports = new __parcel__URL__("brickwarriors.6bb2f002.avif").toString();